// extracted by mini-css-extract-plugin
export var copyStyle = "Copy-module--copyStyle--26174";